<form *ngIf="automationFormGroup" [formGroup]="automationFormGroup">
  <p-card class="p-3" header="Datos generales">
      <div class="grid">
          <div class="col-6 input-field">
              <label for="name">Nombre</label>
              <input pInputText formControlName="name" d-form-field-error />
          </div>
          <div class="col-4 input-field">
              <label for="code">Evento *</label>
              <p-dropdown (onChange)="loadAutomationEvent($event)" formControlName="automationEventId" [required]="true" [options]="events" optionLabel="name" optionValue="id" appendTo="body" [filter]="true" filterBy="name" placeholder="Evento" d-form-field-error ></p-dropdown>
          </div>
          <div class="col-2 input-field">
              <label for="code">Activa *</label>
              <p-checkbox formControlName="enabled" d-form-field-error [binary]="true"></p-checkbox >     
          </div>
          <div class="col-12 input-field" *ngFor="let field of automation.automationEvent?.eventConfig?.fields">
              <label for="{{field.name}}">{{field.label}}</label>
              <input *ngIf="field.inputType=='text'" pInputText [(ngModel)]="automationEventConfig.values[field.name]" [ngModelOptions]="{standalone: true}" d-form-field-error />
              <textarea *ngIf="field.inputType=='textarea'" rows="3" pInputTextarea [(ngModel)]="automationEventConfig.values[field.name]" [ngModelOptions]="{standalone: true}" d-form-field-error></textarea>
              <p-dropdown *ngIf="field.inputType=='select'" [(ngModel)]="automationEventConfig.values[field.name]" [ngModelOptions]="{standalone: true}" d-form-field-error optionLabel="label" optionValue="value"  appendTo="body" [options]="field.optionsItems" ></p-dropdown>
              <p-checkbox *ngIf="field.inputType=='bool'" [(ngModel)]="automationEventConfig.values[field.name]" [ngModelOptions]="{standalone: true}" d-form-field-error [binary]="true"></p-checkbox >     
              <p-multiSelect *ngIf="field.inputType=='multiselect'"  [(ngModel)]="automationEventConfig.values[field.name]" [ngModelOptions]="{standalone: true}" [options]="field.optionsItems" optionLabel="label" optionValue="value" showClear appendTo="body"  d-form-field-error></p-multiSelect> 
              <p-inputNumber *ngIf="field.inputType=='number'"  [(ngModel)]="automationEventConfig.values[field.name]" [ngModelOptions]="{standalone: true}" d-form-field-error />
              <p-calendar *ngIf="field.inputType=='time'" [(ngModel)]="automationEventConfig.values[field.name]" [timeOnly]="true" appendTo="body" formControlName="startHour" d-form-field-error />
            </div>
      </div>

      <div class="mt-4 flex gap-2 justify-content-end">
          <p-button label="Eliminar" *ngIf="allowDelete" icon="pi pi-trash" styleClass="p-button-danger" (click)="delete()"></p-button>
          <div class="flex-grow-1"></div>
          <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
          <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
      </div>
  </p-card>

  <p-tabView>
    <p-tabPanel header="Acciones" [disabled]="!automation.id">
        <div class="flex justify-content-end mb-2">
            <p-button label="Añadir acciones" *ngIf="allowWrite && automation.id" icon="pi pi-plus"  (click)="editAutomationEvent(null)"></p-button>
        </div>

        <p-table styleClass="m-1 mt-4" #grid [value]="automationsActions" [loading]="loading"
            [paginator]="true" [rows]="25" [totalRecords]="totalAutomationsActions" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
            paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th pSortableColumn="name">Acción <p-sortIcon field="name" /></th>
                    <th width="100"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-aaction let-columns="columns">
                <tr (dblclick)="editAutomationEvent(aaction)">
                    <td>{{aaction.action.name}}</td>
                    <td>
                        <div class="flex gap-2 justify-content-end">
                            <p-button *ngIf="allowDelete" (click)="deleteAutomationEvent(aaction)"
                                [rounded]="true" [text]="false" severity="danger"><i
                                    class="pi pi-trash"></i></p-button>
                            <p-button *ngIf="allowWrite" (click)="editAutomationEvent(aaction)"
                                [rounded]="true" [text]="false"><i class="pi pi-pencil"></i></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="2">
                        No se han encontrado acciones
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>
    <p-tabPanel header="Compañias" [disabled]="!automation.id">
        <div class="flex justify-content-end pb-1">
            <p-button label="Añadir compañías" (click)="addCompany({}, false)" icon="pi pi-plus"  *ngIf="allowWrite"></p-button>
        </div>
        <p-table styleClass="mt-4" [value]="automationsCompanies" [paginator]="true" [rows]="25"
                [totalRecords]="totalAutomationsCompanies" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body"
                dataKey="companyId" rowGroupMode="subheader" groupRowsBy="companyId"
                >
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th pSortableColumn="company">Compañía <p-sortIcon field="company"></p-sortIcon></th>
                    <th >Contrato </th>
                    <th width="100"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-company let-columns="columns">
                  <tr>
                    <td>                    
                        {{company.company.name}}
                    </td>
                    <td>
                      {{company.contractId != null?company.contract?.name: "Todos"}}
                  </td>
                    <td>
                      <div class="flex gap-2 justify-content-end">
                        <p-button *ngIf="allowDelete" (click)="deleteCompany(company, false)" [rounded]="true"
                          styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                        <!--<p-button *ngIf="allowWrite" (click)="addCompany(company, true)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>-->
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="2">
                      No se han encontrado compañías
                    </td>
                  </tr>
                </ng-template>
              </p-table>
        
    </p-tabPanel>
</p-tabView>
</form>
<p-confirmDialog></p-confirmDialog>